export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: { default: 'opt' },
  },
  {
    title: that.$l('table_label_evgBulkOrderNo') || '大货订单编号',
    field: 'evgBulkOrderNo',
    minWidth: 140,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_evgBulkOrderStatus') || '状态',
    field: 'evgBulkOrderStatus',
    minWidth: 80,
    align: 'center',
    slots: { default: 'status' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_custOrderNo') || '客户订单号',
    field: 'custOrderNo',
    minWidth: 140,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_custName') || '客户',
    field: 'custName',
    minWidth: 250,
    headerAlign: 'center',
    align: 'left',
    slots: { default: 'displayCustomer' },
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_orderDate') || '订单日期',
    field: 'orderDate',
    minWidth: 110,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_deliveryDate') || '交货日期',
    field: 'deliveryDate',
    minWidth: 110,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_beginShippingDate') || '最早发运日期',
    field: 'beginShippingDate',
    minWidth: 110,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_endShippingDate') || '最晚发运日期',
    field: 'endShippingDate',
    minWidth: 110,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_totalGoodsQty') || '总产品数量',
    field: 'totalGoodsQty',
    minWidth: 110,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_totalAmount') || '订单总金额',
    field: 'totalAmount',
    minWidth: 110,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) => that.format(cellValue),
  },
  {
    title: that.$l('table_label_salesPersonName') || '业务',
    field: 'salesPersonName',
    minWidth: 170,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_merchandiserName') || '跟单',
    field: 'merchandiserName',
    minWidth: 170,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayWh') || '收货仓库',
    field: 'displayWh',
    minWidth: 250,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayWh' },
  },
  {
    title: that.$l('table_label_regionName') || '运抵国',
    field: 'regionName',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_dispatchPort') || '出运港口',
    field: 'dispatchPortName',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_outBillType') || '出单类型',
    field: 'v_outBillType',
    minWidth: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_displayCreate') || '创建人',
    field: 'displayCreate',
    width: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayCreate' },
  },
  {
    title: that.$l('table_label_displayModify') || '修改人',
    field: 'displayModify',
    width: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayModify' },
  },
  {
    title: that.$l('table_label_displayConfirmBy') || '审核人',
    field: 'displayConfirmBy',
    width: 170,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'displayConfirmBy' },
  },
]
